import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { stringify } from "query-string";
import { Link, useLocation } from "react-router-dom";
import { EcoOutlined } from "sprout-ui-icons";
import { Box, Flex, Text } from "sprout-ui-primitives";
import { media } from "sprout-ui-theme";
import styled from "styled-components";
import { Button } from "../Button";
import LandingFooter from "./LandingFooter";
import { LandingMaxWidth } from "./LandingMaxWidth";
const LandingFooterCTAButton = styled(Button)`
  height: 48px;

  pointer-events: auto;
`;
const LandingFooterCTAButtonWrapper = styled(LandingMaxWidth)`
  justify-content: center;
  padding-top: 16px;

  ${media.up("medium")} {
    justify-content: flex-end;
  }

  position: sticky;
  bottom: -64px;
  transition: bottom 0.15s linear;

  body.is-scrolled & {
    bottom: 16px;
  }

  pointer-events: none;
`;
const LandingPage = (props)=>{
    const { children  } = props;
    const { pathname  } = useLocation();
    return /*#__PURE__*/ _jsxs(Box, {
        children: [
            children,
            /*#__PURE__*/ _jsx(LandingFooter, {}),
            /*#__PURE__*/ _jsx(LandingFooterCTAButtonWrapper, {
                as: Flex,
                alignItems: "center",
                maxWidth: "1072px",
                px: 3,
                children: /*#__PURE__*/ _jsxs(LandingFooterCTAButton, {
                    variant: "dark-purple",
                    as: Link,
                    to: {
                        pathname: "/signup",
                        search: stringify({
                            next: pathname
                        })
                    },
                    children: [
                        /*#__PURE__*/ _jsx(EcoOutlined, {}),
                        /*#__PURE__*/ _jsx(Text, {
                            as: "span",
                            ml: 0,
                            children: "Get organized for free"
                        })
                    ]
                })
            })
        ]
    });
};
export default LandingPage;
